import { createTheme } from '@material-ui/core/styles';

import { breakpointsOptions } from './breakpoints';
// import { makeComponents } from './components';
import { palette } from './palette';
import { typography, withResponsiveTypography } from './typography';

// export { Theme } from '@material-ui/core';

let theme = createTheme({
  breakpoints: breakpointsOptions,
  palette,
  shape: {
    borderRadius: 6,
  },
  typography,
});

theme = withResponsiveTypography(theme);
// theme.components = makeComponents(theme);

export { theme };
